import { createContext } from 'react';
import { createTheme, themes } from '@chegg-ui/theme';
import { getRioClient } from '@chegg-me-components/utils';
export var FooterLegalContext = /*#__PURE__*/createContext({
  envUrl: '/',
  dataTestPrefix: 'footer-legal'
});
export var FooterLegalTheme = createTheme(themes.horizon);
export var rioClient = getRioClient();